import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';

@inject("appStore")
@observer
class CloseSurvey extends Component {
    render() {
        const brandColor = this.props.appStore.appConfig.content.brand.brandColor;
        const textColor = this.props.appStore.appConfig.content.brand.textColor;
        const backgroundColor = {
            backgroundColor: `rgba(${brandColor.r}, ${brandColor.g}, ${brandColor.b}, ${brandColor.a})`
        };
        const color = {
            color: `rgba(${textColor.r}, ${textColor.g}, ${textColor.b}, ${textColor.a})`
        };

        return (
            <div className={(this.props.appStore.isMobile) ? "CloseSurvey mobile" : "CloseSurvey desktop"}
                 style={backgroundColor}>
                <div className="container" style={color}>
                    <div className="content">
                        <h2 className="header">{'Thank you'}</h2>
                        <p className="copy">
                            {'The survey is closed. Thanks for sharing your experiences!'}
                        </p>
                    </div>
                    {/* //TODO: Replace the above hard coded stuff to below*/}
                    {/*<div className="content">
                        <h2 className="header">{this.props.appStore.appConfig.content.closed.headline}</h2>
                        <p className="copy">
                            {this.props.appStore.appConfig.content.closed.text}
                        </p>
                    </div>
                    {this.props.appStore.appConfig.content.closed.link &&
                    <a href={this.props.appStore.appConfig.content.closed.link} className="take-again">
                        {this.props.appStore.appConfig.content.closed.label}
                    </a>}*/}
                </div>
            </div>
        );
    }
}

export default CloseSurvey;



// WEBPACK FOOTER //
// ./src/scenes/CloseSurvey/index.js